import { FC, ReactElement } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { CommonRouteEnum } from 'configs/routes'

import { AuthRouteEnum } from 'features/auth/constants/routes'
import { useIsLoggedIn } from 'features/auth/hooks'
import { useUserMeState } from 'features/user/hooks'
import { UserModel } from 'features/user/models'

import { CommonLocationState } from 'shared/types/common'
import { getPathByLocation } from 'shared/utils/url'

type ProtectedRouteProps = {
  component: ReactElement
  permitted?: (user: UserModel, locationState?: any) => boolean
  onlyGuest?: boolean
  redirectPath?: string
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({
  component,
  permitted,
  onlyGuest = false,
  redirectPath,
}) => {
  const location = useLocation()
  const navigationState: CommonLocationState = { from: getPathByLocation(location) }

  const isLoggedIn = useIsLoggedIn()
  const { data: user } = useUserMeState()

  if (onlyGuest) {
    if (isLoggedIn) {
      const to = location.state?.from || redirectPath || CommonRouteEnum.Home
      return <Navigate to={to} replace state={navigationState} />
    } else {
      return component
    }
  } else {
    if (isLoggedIn) {
      if (!permitted || (user && permitted(user, location.state))) {
        return component
      } else {
        const to = redirectPath || CommonRouteEnum.Home
        return <Navigate to={to} replace state={navigationState} />
      }
    } else {
      const to = redirectPath || AuthRouteEnum.Login
      return <Navigate to={to} replace state={navigationState} />
    }
  }
}

export default ProtectedRoute
